/**
 * Constants for the Weekly Management Report
 */

// Job type classification keywords (matched against cart item descriptions / job data)
export const JOB_TYPE_KEYWORDS = {
  Diagnosis: ['diagnosis', 'diagnostic', 'scan', 'check engine'],
  'Body Work': ['body', 'paint', 'spray', 'panel', 'dent', 'bumper'],
  'Quick Service': ['quick', 'oil change', 'filter', 'top up', 'top-up', 'routine'],
  Electrical: ['electrical', 'wiring', 'battery', 'alternator', 'starter', 'ac ', 'a/c'],
};

export const DEFAULT_JOB_TYPE = 'Mechanical Repairs';

// Budget review segments
export const BUDGET_SEGMENTS = [
  'Mechanical',
  'Electrical',
  'Body Work',
  'Fleet',
  'Paint',
  'Special',
];

// Expense categories for breakdown
export const EXPENSE_CATEGORIES = [
  'Spare Parts',
  'Diesel',
  'Utilities',
  'Logistics',
  'Salaries',
  'Contractor',
  'Rent',
  'Internet',
  'Miscellaneous',
];

// Revenue account identifiers (substrings matched in modeOfPayment)
export const REVENUE_ACCOUNTS = ['revenue', 'stanbic revenue', 'access revenue'];
export const OPEX_ACCOUNTS = ['opex', 'stanbic opex', 'access opex'];
export const CAPEX_ACCOUNTS = ['capex', 'capital'];

// VAT rate
export const VAT_RATE = 0.075;

// Customer type mapping
export const CUSTOMER_TYPE_MAP = {
  Corporate: 'Fleet/Credit',
  Private: 'Cash',
};
